import { Warehouse, Boxes, FileText, Route, Receipt } from 'lucide-react';
import { useReveal } from '@/lib/useReveal';
import { Section, Container, Display, Lead, CtaLink } from '@/components/system';

/** Transitarias — freight consolidators. Mi Cargo is "en camino"; the mass scan already lives in Mi Admin. */
const items = [
  { icon: Warehouse, label: 'Recepción por lote' },
  { icon: Boxes, label: 'Consolidación por destino' },
  { icon: FileText, label: 'Manifiestos de contenedor' },
  { icon: Route, label: 'Trazabilidad por traspaso' },
  { icon: Receipt, label: 'Facturación a tus agencias' },
];

export function TransitariasTeaser() {
  const ref = useReveal<HTMLElement>();
  return (
    <Section tone="dark" ref={ref}>
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <p data-reveal className="flex items-center justify-center gap-3 text-text-muted font-semibold mb-5">
            <img src="/logos/apps/cargo.png" alt="" width={32} height={32} loading="lazy" className="w-8 h-8 rounded-lg" />
            Mi Cargo · Para transitarias · En camino
          </p>
          <Display data-reveal size="lg" className="text-white">
            De cien agencias a un solo manifiesto.
          </Display>
          <Lead data-reveal dark className="mt-6 mx-auto max-w-3xl">
            Recibe la carga de todas tus agencias, consolídala por destino y arma el manifiesto del
            contenedor — con escaneo masivo en almacén y trazabilidad en cada traspaso.
          </Lead>
          <div data-reveal className="mt-10 flex flex-wrap justify-center gap-3">
            {items.map((i) => (
              <span key={i.label} className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium text-text-light">
                <i.icon className="w-4 h-4 text-brand-light" />
                {i.label}
              </span>
            ))}
          </div>
          <div data-reveal className="mt-10">
            <CtaLink to="/plataforma/mi-cargo" dark>Más sobre Mi Cargo y la Suite Empresarial</CtaLink>
          </div>
        </div>
      </Container>
    </Section>
  );
}
